<template>
  <div class="addproject">
    <h2>Add <span>Your Project</span></h2>
    <router-link to="/" class="backtoprojects-top"
      >&lt; back to projects</router-link
    >
    <h3>{{ introText[0] }}</h3>
    <h3>{{ introText[1] }}</h3>

    <form id="addproject-form" @submit="submitForm" action="#" method="post">
      <div class="form-column">
        <!-- form field -->
        <div class="formfield--wide">
          <label for="q1" class="label--wide">{{ questions[0] }}</label>
          <textarea
            type="text"
            name="q1"
            id="q1"
            v-model="q1"
            value=""
            tabindex="1"
          />
        </div>

        <!-- form field -->
        <div class="formfield--wide">
          <label for="q2" class="label--wide">{{ questions[1] }}</label>
          <textarea
            type="text"
            name="q2"
            id="q2"
            v-model="q2"
            value=""
            tabindex="2"
          />
        </div>

        <!-- form field -->
        <div class="formfield--wide">
          <label for="q3" class="label--wide">{{ questions[2] }}</label>
          <textarea
            type="text"
            name="q3"
            id="q3"
            v-model="q3"
            value=""
            tabindex="3"
          />
        </div>

        <!-- form field -->
        <div class="formfield--wide">
          <label for="q4" class="label--wide">{{ questions[3] }}</label>
          <textarea
            type="text"
            name="q4"
            id="q4"
            v-model="q4"
            value=""
            tabindex="4"
          />
        </div>
      </div>

      <!-- contact details -->
      <div class="form-column">
        <div>
          <h4>Personal Contact</h4>
          <!-- form field -->
          <div class="formfield--short">
            <label class="label--short" for="q5">Name</label>
            <input
              type="text"
              name="q5"
              id="q5"
              v-model="q5"
              value=""
              tabindex="5"
            />
          </div>

          <!-- form field -->
          <div class="formfield--short">
            <label class="label--short" for="q6">Phone</label>
            <input
              type="text"
              name="q6"
              id="q6"
              v-model="q6"
              value=""
              tabindex="6"
            />
          </div>

          <!-- form field -->
          <div class="formfield--short">
            <label class="label--short" for="q7">E-Mail</label>
            <input
              type="text"
              name="q7"
              id="q7"
              v-model="q7"
              value=""
              tabindex="7"
            />
          </div>
        </div>

        <!-- upload files details -->
        <div class="upload-section">
          <h4>Upload Files</h4>
          <h5>{{ uploadFilesText[0] }}</h5>

          <label for="file1"><span>Select a file</span></label>
          <input
            type="file"
            id="file1"
            name="file1"
            accept="image/png, image/jpeg, application/pdf"
            @change="handleFileUpload($event, 'file1')"
          />

          <label for="file2"><span>Select a file</span></label>
          <input
            type="file"
            id="file2"
            name="file2"
            accept="image/png, image/jpeg, application/pdf"
            @change="handleFileUpload($event, 'file2')"
          />

          <label for="file3"><span>Select a file</span></label>
          <input
            type="file"
            id="file3"
            name="file3"
            accept="image/png, image/jpeg, application/pdf"
            @change="handleFileUpload($event, 'file3')"
          />
        </div>

        <div class="submit-section">
          <h5>{{ uploadFilesText[1] }}</h5>
          <div class="submit-section-withmessage">
            <h6>Your project was successfully sent!</h6>
            <input type="submit" value="Send" />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      q1text: "",
      q2text: "",
      q3text: "",
      q4text: "",
      introText: [],
      questions: [],
      uploadFilesText: [],
      q1: "",
      q2: "",
      q3: "",
      q4: "",
      q5: "",
      q6: "",
      q7: "",
      file1: "",
      file2: "",
      file3: ""
    };
  },
  mounted() {
    var self = this;

    // get the questions text
    axios
      .get("https://api.blue-temple.com/configuration")
      .then(function(res) {
        // questions 1-4 text
        let x;
        for (x = 1; x < 5; x++) {
          var qtext = res.data.data.filter(obj => {
            return obj.key === "QUESTION_" + x;
          });
          self.questions.push(qtext[0]["defaultValue"]);
        }

        // upload files text
        let y;
        for (y = 1; y < 3; y++) {
          var uploadText = res.data.data.filter(obj => {
            return obj.key === "FORM_UPLOAD_TEXT_" + y;
          });
          self.uploadFilesText.push(uploadText[0]["defaultValue"]);
        }

        // intro text
        let z;
        for (z = 1; z < 3; z++) {
          var addIntroText = res.data.data.filter(obj => {
            return obj.key === "ADD_PROJECT_INTRO_TEXT_" + z;
          });
          self.introText.push(addIntroText[0]["defaultValue"]);
        }
      })
      .catch(function(error) {
        console.log("Error", error);
      });
  },
  methods: {
    handleFileUpload(event, fieldId) {
      this[fieldId] = event.target.files[0];
      // change title
      var titleArr = document.querySelector("#" + fieldId).value.split("\\");
      var title = titleArr[titleArr.length - 1];
      document
        .querySelector('label[for="' + fieldId + '"] span')
        .setAttribute("data-value", title);

      console.log(fieldId, title);
    },
    submitForm(e) {
      e.preventDefault();

      var form = e.srcElement;
      let bodyFormData = new FormData();
      bodyFormData.set("question1", this.q1);
      bodyFormData.set("question2", this.q2);
      bodyFormData.set("question3", this.q3);
      bodyFormData.set("question4", this.q4);
      bodyFormData.set("contactName", this.q5);
      bodyFormData.set("contactPhone", this.q6);
      bodyFormData.set("contactEmail", this.q7);
      if (this.file1) bodyFormData.set("file1", this.file1, this.file1.name);
      if (this.file2) bodyFormData.set("file2", this.file2, this.file2.name);
      if (this.file3) bodyFormData.set("file3", this.file3, this.file3.name);

      axios({
        method: "post",
        url: "https://api.blue-temple.com/project-request/create",
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" }
      })
        .then(function(response) {
          //handle success
          console.log(response);

          // show msg
          document
            .querySelector(".submit-section-withmessage")
            .classList.add("show");

          form.reset();
          self.q1 = "";
          self.q2 = "";
          self.q3 = "";
          self.q4 = "";
          self.q5 = "";
          self.q6 = "";
          self.q7 = "";
          self.file1 = "";
          document
            .querySelector('label[for="file1"] span')
            .setAttribute("data-value", "");
          self.file2 = "";
          document
            .querySelector('label[for="file2"] span')
            .setAttribute("data-value", "");
          self.file3 = "";
          document
            .querySelector('label[for="file2"] span')
            .setAttribute("data-value", "");
        })
        .catch(function(response) {
          //handle error
          console.log(response);
        });
    }
  },
  beforeCreate: function() {
    document.body.className = "class-addproject";
  }
};
</script>

<style scoped lang="scss">
.addproject {
  display: block;
  width: 100%;
  padding: 20px;

  // .backtoprojects {
  //   display: none;
  // }

  h2 {
    display: block;
    margin-bottom: 20px;
    font-family: "rajdhanibold";
    font-size: 26px;
    font-weight: normal;
    color: $color-light;
    text-transform: uppercase;

    span {
      display: block;
      font-family: "rajdhaniregular";
    }
  }

  h3 {
    display: block;
    font-family: "rajdhaniregular";
    font-size: 18px;
    font-weight: normal;
    color: $color-light;

    + h3 {
      font-size: 14px;
    }
  }

  h4 {
    display: block;
    margin-bottom: 14px;
    font-family: "rajdhaniregular";
    font-weight: normal;
    font-size: 20px;
    line-height: 22px;
    color: $color-light;
  }

  h5 {
    margin: 0;
    font-family: "rajdhaniregular";
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    color: $color-light;
  }

  p {
    display: block;
    margin: 20px 0;
    font-family: "rajdhaniregular";
    font-size: 14px;
    line-height: 20px;
    color: $color-light;
  }

  form {
    display: block;
    margin-top: 40px;
  }

  .formfield {
    &--wide {
      display: block;
      margin-bottom: 25px;
    }

    &--short {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: middle;
      margin-bottom: 10px;
    }
  }

  .label {
    &--wide {
      display: block;
      margin-bottom: 10px;
      font-family: "rajdhaniregular";
      font-size: 20px;
      line-height: 22px;
      color: $color-light;
    }

    &--short {
      display: block;
      width: 70px;
      height: 38px;
      margin-right: 20px;
      padding-top: 10px;
      font-family: "rajdhanibold";
      font-size: 18px;
      line-height: 20px;
      color: $color-light;
    }
  }

  input {
    display: block;
    width: 100%;
    background: $color-formbg;
    border: 0;

    &[type="submit"]:hover {
    }
  }

  textarea {
    width: 100%;
    height: 100px;
    font-family: "rajdhaniregular";
    font-size: 14px;
    line-height: 18px;
    color: $color-light;
    border: 0;
    background: $color-formbg;
  }

  .upload-section {
    margin-top: 40px;

    input {
      height: 38px;
      margin-top: 14px;
    }

    label {
      position: relative;
      display: block;
      width: 100%;
      height: 38px;
      margin: 14px 0 -52px;
      font-family: "rajdhanibold";
      font-size: 16px;
      line-height: 18px;
      color: $color-light;
      background: $color-formbg;
      z-index: 40;

      span {
        &:hover {
          cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
          background: $color-light;
        }

        &:nth-child(1):before {
          content: attr(data-value);
        }

        &:nth-child(2):before {
          content: attr(data-value);
        }

        &:nth-child(3):before {
          content: attr(data-value);
        }

        &:before {
          position: absolute;
          left: 10px;
          display: block;
          max-width: 57%;
          margin-top: 1px;
          font-size: 12px;
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
        }
      }

      span {
        display: block;
        width: 40%;
        height: 100%;
        margin: 0 0 0 auto;
        padding: 10px 0;
        text-align: center;
        text-transform: uppercase;
        color: $color-darkgrey;
        background: $color-formlightbg;
      }
    }
  }

  .submit-section {
    h5 {
      margin: 15px 0;
    }

    input {
      display: block;
      width: auto;
      padding: 8px 52px;
      font-family: "rajdhanibold";
      font-size: 20px;
      line-height: 20px;
      text-transform: uppercase;
      color: $color-light;
      border: 2px solid $color-light;
      background: transparent;

      &:hover {
        background: $color-light;
        color: $color-darkgrey;
        cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
      }
    }

    &-withmessage {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      &.show {
        h6 {
          display: block;
        }
      }

      h6 {
        display: none;
        margin-right: 20px;
        font-family: "rajdhanibold";
        font-size: 16px;
        line-height: 22px;
        color: $color-light;
        text-transform: uppercase;
      }
    }
  }
}

@media screen and (min-width: 768px) {
  .addproject {
    height: 100vh;
    overflow-y: scroll;
    padding: 24px;

    h2 {
      margin-top: 7px;
      font-size: 32px;
      line-height: 32px;
    }

    h3 {
      font-size: 20px;
      line-height: 22px;

      + h3 {
        margin-top: 6px;
        font-size: 14px;
        line-height: 16px;
      }
    }

    .backtoprojects-top {
      margin-top: 8px;
    }
  }
}

@media screen and (min-width: 1024px) {
  .addproject {
    padding: 3.1vw;

    h2 {
      margin-bottom: 30px;
      font-size: 52px;
      line-height: 48px;
    }

    h3 {
      max-width: 33vw;
      font-size: 24px;
      line-height: 28px;

      + h3 {
        font-size: 18px;
        line-height: 24px;
      }
    }

    form {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;

      .form-column {
        display: block;
        width: calc(50% - 30px);
        max-width: 34vw;
      }

      .upload-section {
        margin-top: 40px;

        input {
          height: 38px;
          margin-top: 14px;
        }

        label {
          span {
            max-width: 170px;
          }
        }
      }

      .submit-section {
        input {
          display: block;
          padding: 16px 84px;
        }

        &-withmessage {
          margin: 50px 0 0 auto;
        }
      }
    }
  }
}
</style>
